import InputDatetime from "./input-datetime.jsx";
import React, { useId } from "react";

const PeriodInput = ({startDateId, endDateId, startDate, endDate, setFilter, label = 'Período entre', endLabel, dateFormat = 'L', cols = 4, returnDateObj = true, required = false}) => {
  const generatedStartDateId = useId();
  const generatedEndDateId = useId();
  const _startDateId = startDateId ?? generatedStartDateId;
  const _endDateId = endDateId ?? generatedEndDateId;

  const handleDateChange = (id, date) => {
    const value = date ?? (returnDateObj ? null : "");
    setFilter(prev => ({ ...prev, [id]: value }));
  };

  return(
    <div className={`${ cols ? `col-span-${cols}` : 'col-span-4' } flex items-stretch h-full!`}>
          <InputDatetime
            id={_startDateId}
            label={label}
            required={required}
            selected={startDate}
            onChange={(date) => handleDateChange(_startDateId, date)}
            dateFormat={dateFormat}
            returnDateObj={returnDateObj}
            customIcon
            inputClass="!rounded-e-none"
            classNameWrapper="w-[47%]"
          />

        <div className="border border-[#E5E7EB] px-4 py-2 text-sm leading-none">à</div>

        <InputDatetime
            id={_endDateId}
            label={endLabel}
            required={required}
            selected={endDate}
            onChange={(date) => handleDateChange(_endDateId, date)}
            dateFormat={dateFormat}
            returnDateObj={returnDateObj}
            inputClass="!rounded-s-none"
            classNameWrapper="w-[47%]"
        />
    </div>

  )
}

export default PeriodInput;